import { render, staticRenderFns } from "./GroupCustomer.vue?vue&type=template&id=36d7b3d8&"
import script from "./GroupCustomer.vue?vue&type=script&lang=ts&"
export * from "./GroupCustomer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports